import React from 'react';
import PatientRegister from '../components/PatientRegister';
import Breadcrumb from '../../../components/ui/Breadcrumb';

const PatientRegisterPage: React.FC = () => {
  return (
    <>
      {/* Breadcrumbs */}
      <div className="page-header">
        <div className="row">
          <div className="col-sm-12">
            <Breadcrumb items={[{ label: 'Pacientes', to: '/patients' }, { label: 'Nuevo Paciente' }]} />
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-sm-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Registro de Paciente</h4>
            </div>
            <div className="card-body">
              <PatientRegister />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PatientRegisterPage;
